import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { getHTMLTag } from '../shared';
import { getThemeConfig, TypographyContainer } from '../styles';

var Typography = function Typography(_ref) {
  var id = _ref.id,
      variant = _ref.variant,
      tag = _ref.tag,
      children = _ref.children,
      enableTextShadow = _ref.enableTextShadow,
      className = _ref.className,
      display = _ref.display,
      textShadowMixBlendMode = _ref.textShadowMixBlendMode,
      variantType = _ref.variantType,
      underline = _ref.underline,
      theme = _ref.theme,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, ["id", "variant", "tag", "children", "enableTextShadow", "className", "display", "textShadowMixBlendMode", "variantType", "underline", "theme", "data-test"]);

  var componentTheme = useComponentTheme({
    name: 'Typography',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(TypographyContainer, _extends({
    id: id,
    variant: variant,
    as: getHTMLTag(variant, variantType, tag),
    className: className,
    enableTextShadow: enableTextShadow,
    customTheme: componentTheme,
    textContent: children,
    display: display,
    textShadowMixBlendMode: textShadowMixBlendMode,
    "data-test": dataTest ? dataTest : undefined,
    variantType: variantType,
    underline: underline
  }, props), children);
};

Typography.displayName = 'Typography';
export default Typography;